import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/routing/ProtectedRoute';

import Login from './pages/auth/Login';
import Dashboard from './pages/dashboard/Dashboard';
import Employees from './pages/employees/Employees';
import Clients from './pages/clients/Clients';
import ClientDetail from './pages/clients/ClientDetail';
import Projects from './pages/projects/Projects';
import ProjectDetail from './pages/projects/ProjectDetail';
import Tasks from './pages/tasks/Tasks';
import Documents from './pages/documents/Documents';
import DocumentRequests from './pages/documents/DocumentRequests';
import Tickets from './pages/tickets/Tickets';
import ClientTickets from './pages/tickets/ClientTickets';
import Communication from './pages/communication/Communication';
import Announcements from './pages/communication/Announcements';
import KnowledgeBase from './pages/knowledgebase/KnowledgeBase';
import Timesheets from './pages/timesheets/Timesheets';
import Invoices from './pages/invoices/Invoices';
import Payments from './pages/payments/Payments';
import Reports from './pages/reports/Reports';
import Notifications from './pages/notifications/Notifications';
import AuditLogs from './pages/settings/AuditLogs';

const STAFF_ONLY = ['super_admin', 'admin', 'employee'];
const MANAGERS_ONLY = ['super_admin', 'admin'];

function LoginRoute() {
  const { actor, loading } = useAuth();
  if (loading) return null;
  if (actor) return <Navigate to="/dashboard" replace />;
  return <Login />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />

          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

          <Route path="/employees" element={<ProtectedRoute allowRoles={MANAGERS_ONLY}><Employees /></ProtectedRoute>} />

          <Route path="/clients" element={<ProtectedRoute allowRoles={STAFF_ONLY}><Clients /></ProtectedRoute>} />
          <Route path="/clients/:id" element={<ProtectedRoute allowRoles={STAFF_ONLY}><ClientDetail /></ProtectedRoute>} />

          <Route path="/projects" element={<ProtectedRoute><Projects /></ProtectedRoute>} />
          <Route path="/projects/:id" element={<ProtectedRoute><ProjectDetail /></ProtectedRoute>} />

          <Route path="/tasks" element={<ProtectedRoute allowRoles={STAFF_ONLY}><Tasks /></ProtectedRoute>} />

          <Route path="/documents" element={<ProtectedRoute><Documents /></ProtectedRoute>} />
          <Route path="/document-requests" element={<ProtectedRoute><DocumentRequests /></ProtectedRoute>} />

          <Route path="/tickets" element={<ProtectedRoute allowRoles={STAFF_ONLY}><Tickets /></ProtectedRoute>} />
          <Route path="/client-tickets" element={<ProtectedRoute><ClientTickets /></ProtectedRoute>} />

          <Route path="/communication" element={<ProtectedRoute allowRoles={STAFF_ONLY}><Communication /></ProtectedRoute>} />
          <Route path="/announcements" element={<ProtectedRoute><Announcements /></ProtectedRoute>} />
          <Route path="/knowledge-base" element={<ProtectedRoute allowRoles={STAFF_ONLY}><KnowledgeBase /></ProtectedRoute>} />

          <Route path="/timesheets" element={<ProtectedRoute allowRoles={STAFF_ONLY}><Timesheets /></ProtectedRoute>} />

          <Route path="/invoices" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
          <Route path="/payments" element={<ProtectedRoute><Payments /></ProtectedRoute>} />

          <Route path="/reports" element={<ProtectedRoute allowRoles={MANAGERS_ONLY}><Reports /></ProtectedRoute>} />
          <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
          <Route path="/audit-logs" element={<ProtectedRoute allowRoles={['super_admin']}><AuditLogs /></ProtectedRoute>} />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
